import { FREE_SIGNUP_CREDITS, formatSignupCreditsLabel } from '../../config/credits'

export type LandingPlanCard = {
  key: string
  title: string
  price: string
  desc: string
  accent?: boolean
}

export const DEFAULT_LANDING_PLANS: LandingPlanCard[] = [
  {
    key: 'free',
    title: 'Free',
    price: '0 ₽',
    desc: `${formatSignupCreditsLabel()} · 14 дней пробного премиума`,
    accent: true,
  },
  { key: 'basic', title: 'Базовый', price: '300 ₽/мес', desc: '55 подписочных кр · ИИ Чат 150 сообщ.' },
  { key: 'medium', title: 'Средний', price: '900 ₽/мес', desc: '180 подписочных кр · ИИ Чат 600 сообщ.' },
  { key: 'premium', title: 'Премиум', price: '1 900 ₽/мес', desc: '400 подписочных кр · ИИ Чат без лимита' },
]

export type PlansApiFree = {
  signup_credits?: number
  subscription_credits_monthly?: number
  trial_days?: number
}

export type PlansApiPaid = {
  slug: string
  name: string
  price_rub: number
  subscription_credits_monthly: number
  ai_chat_message_limit: number | null
}

/** Merge API catalog with defaults so empty `plans` does not drop paid cards. */
export function mergeLandingPlans(free: PlansApiFree, apiPlans: PlansApiPaid[]): LandingPlanCard[] {
  const paidBySlug = new Map(apiPlans.map(p => [p.slug, p]))
  const signupCredits = free.signup_credits ?? free.subscription_credits_monthly ?? FREE_SIGNUP_CREDITS
  const freeDesc = `${formatSignupCreditsLabel(signupCredits)} · ${free.trial_days ?? 14} дней пробного премиума`

  return DEFAULT_LANDING_PLANS.map(defaultCard => {
    if (defaultCard.key === 'free') {
      return { ...defaultCard, desc: freeDesc, accent: true }
    }
    const p = paidBySlug.get(defaultCard.key)
    if (!p) return { ...defaultCard, accent: false }
    const chatLimit =
      p.ai_chat_message_limit == null ? 'без лимита' : `${p.ai_chat_message_limit} сообщ.`
    return {
      key: p.slug,
      title: p.name,
      price: `${p.price_rub.toLocaleString('ru-RU')} ₽/мес`,
      desc: `${p.subscription_credits_monthly} подписочных кр · ИИ Чат ${chatLimit}`,
      accent: false,
    }
  })
}
